<template>
  <el-dialog
    :title="$t('businessOpportunityManageMessages.add.title')"
    :visible.sync="visible"
    width="70%"
    @close="handleClose"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="110px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            :label="$t('businessOpportunityManageMessages.add.opportunityName')"
            prop="opportunityName"
          >
            <el-input
              v-model="form.opportunityName"
              placeholder="请输入商机名称"
              style="width: 100%"
            />
          </el-form-item>
          <!-- 商机来源：修复重复key，key固定用statusCd(唯一) -->
          <el-form-item
            :label="$t('businessOpportunityManageMessages.add.source')"
            prop="source"
          >
            <el-select
              v-model="form.source"
              placeholder="请选择或手动输入来源"
              style="width: 100%"
              filterable
              allow-create
              no-data-text="可直接输入新来源"
            >
              <el-option
                v-for="item in sourceOptions"
                :key="item.statusCd"
                :label="item.description"
                :value="item.description"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('businessOpportunityManageMessages.add.expectedValue')"
            prop="expectedValue"
          >
            <!-- 新增 readonly 禁止手动输入，step限制小数精度 -->
            <el-input
              v-model="form.expectedValue"
              placeholder="选择房源后自动计算面积"
              style="width: 100%"
              type="number"
              readonly
              step="0.01"
            />
          </el-form-item>
          <el-form-item
            :label="$t('businessOpportunityManageMessages.add.expectedDealDate')"
            prop="expectedDealDate"
          >
            <el-date-picker
              v-model="form.expectedDealDate"
              type="date"
              placeholder="年/月/日"
              style="width: 100%"
              :disabled-date="disabledPastDate"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            :label="$t('businessOpportunityManageMessages.add.opportunityType')"
            prop="opportunityType"
          >
            <el-select
              v-model="form.opportunityType"
              placeholder="请选择商机类型"
              style="width: 100%"
              :disabled="!opportunityTypeOptions.length"
            >
              <el-option
                v-for="item in opportunityTypeOptions"
                :key="item.statusCd"
                :label="item.description"
                :value="item.statusCd"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('businessOpportunityManageMessages.add.negotiationProgress')"
            prop="negotiationProgress"
          >
            <el-select
              v-model="form.negotiationProgress"
              placeholder="请选择谈判进度"
              style="width: 100%"
              :disabled="!negotiationProgressOptions.length"
            >
              <el-option
                v-for="item in negotiationProgressOptions"
                :key="item.statusCd"
                :label="item.description"
                :value="item.statusCd"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$t('businessOpportunityManageMessages.add.customerName')"
            prop="customerName"
          >
            <el-input
              v-model="form.customerName"
              placeholder="请选择或输入客户名称"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item
            :label="$t('businessOpportunityManageMessages.add.status')"
            prop="status"
          >
            <el-select
              v-model="form.status"
              placeholder="请选择状态"
              style="width: 100%"
              :disabled="!statusOptions.length"
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.statusCd"
                :label="item.description"
                :value="item.statusCd"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('businessOpportunityManageMessages.add.responsiblePerson')"
            prop="responsiblePerson"
          >
            <el-select
              v-model="form.responsiblePerson"
              placeholder="请选择负责人"
              style="width: 100%"
              filterable
            >
              <el-option
                v-for="user in userOptions"
                :key="user.name"
                :label="user.name"
                :value="user.name"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('businessOpportunityManageMessages.add.industryType')"
            prop="industryType"
          >
            <el-input
              v-model="form.industryType"
              placeholder="请输入行业类型"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item
            :label="$t('businessOpportunityManageMessages.add.roomId')"
            prop="roomId"
          >
            <el-select
              v-model="form.roomId"
              placeholder="请选择房源（可多选）"
              style="width: 100%"
              filterable
              multiple
              :disabled="!localRoomOptions.length"
              @change="calcTotalArea"
            >
              <el-option
                v-for="item in localRoomOptions"
                :key="item.roomId"
                :label="item.roomName"
                :value="item.roomId"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item
        :label="$t('businessOpportunityManageMessages.add.description')"
        prop="description"
      >
        <el-input
          v-model="form.description"
          type="textarea"
          :rows="4"
          placeholder="请输入商机描述"
          maxlength="500"
          style="width: 100%"
        />
      </el-form-item>

      <el-form-item
        :label="$t('businessOpportunityManageMessages.add.attachments')"
        prop="attachments"
      >
        <el-upload
          class="upload-demo"
          drag
          action="/callComponent/upload/uploadFile/uploadImage"
          accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
          :limit="1"
          name="uploadFile"
          :data="uploadExtraParams"
          :file-list="fileList"
          :on-success="handleUploadSuccess"
          :on-remove="handleRemove"
          :auto-upload="true"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">
            支持 PDF, Word, Excel, PPT (单个文件最大 10MB)
          </div>
        </el-upload>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{ $t("common.cancel") }}</el-button>
      <el-button type="primary" @click="saveBusinessOpportunity">{{
        $t("common.save")
      }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  saveBusinessOpportunity,
  selectStaffInfos,
  getRoomInfoByCommunity,
} from "@/api/businessOpportunity/businessOpportunityApi";
import { getDict } from "@/api/community/communityApi";
import { getCommunityId } from "@/api/community/communityApi";

export default {
  name: "AddBusinessOpportunity",
  props: {
    roomOptions: {
      type: Array,
      default: () => [],
    },
    // 新增：从父组件接收小区ID
    communityId: {
      type: [String, Number],
      default: ""
    }
  },
  data() {
    return {
      uploadExtraParams: {
        communityId: "",
      },
      visible: false,
      form: {
        opportunityName: "",
        customerName: "",
        source: "",
        status: "",
        expectedValue: null,
        responsiblePerson: "",
        roomId: [],
        expectedDealDate: "",
        description: "",
        attachments: "",
        opportunityType: "",
        industryType: "",
        negotiationProgress: "",
      },
      sourceOptions: [],
      opportunityTypeOptions: [],
      negotiationProgressOptions: [],
      statusOptions: [],
      userOptions: [],
      localRoomOptions: [],
      fileList: [],
      progress: 0,
      isDictLoaded: false,
      isStaffLoaded: false,
      rules: {
        opportunityName: [
          { required: true, message: "请输入商机名称", trigger: "blur" },
          { max: 100, message: "商机名称最多100个字符", trigger: "blur" },
        ],
        customerName: [
          { required: true, message: "请选择或输入客户名称", trigger: "blur" },
        ],
        source: [
          { required: true, message: "请输入或选择商机来源", trigger: "blur/change" },
        ],
        status: [
          { required: true, message: "请选择商机状态", trigger: "change" },
        ],
        expectedValue: [
          { required: true, message: "请选择房源自动生成需求面积", trigger: "blur,change" },
        ],
        responsiblePerson: [
          { required: true, message: "请选择负责人", trigger: "change" },
        ],
        expectedDealDate: [
          { required: false, message: "请选择预计成交日期", trigger: "change" },
        ],
        description: [
          { max: 500, message: "商机描述最多500个字符", trigger: "blur" },
        ],
        roomId: [{ required: true, message: "请选择房源", trigger: "change" }],
      },
    };
  },
  created() {
    // 初始化小区ID & 上传参数
    const cid = this.communityId || getCommunityId();
    this.uploadExtraParams.communityId = cid;
    this.preloadBaseData();
  },
  methods: {
    // 新增：计算选中房源总面积，保留两位小数，自动清除校验提示
    calcTotalArea() {
      const selectedIds = this.form.roomId || [];
      let total = 0;
      this.localRoomOptions.forEach(room => {
        if (selectedIds.includes(room.roomId)) {
          total += Number(room.roomArea || 0);
        }
      });
      // 四舍五入保留2位小数
      const fixedArea = Number(total.toFixed(2));
      this.form.expectedValue = fixedArea > 0 ? fixedArea : null;
      // 赋值后清除面积字段校验红框提示
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate("expectedValue");
        }
      });
    },

    async preloadBaseData() {
      try {
        await Promise.all([this.loadDictData(true), this.loadStaffData(true)]);
      } catch (error) {
        this.$message.warning("基础数据加载失败，打开弹窗时将自动重试");
        console.error("预加载基础数据异常:", error);
      }
    },

    async open(editData = null) {
      this.visible = true;
      this.resetForm();
      const cid = this.communityId || getCommunityId();
      this.uploadExtraParams.communityId = cid;

      try {
        // 1. 优先加载房源列表（必须最先执行）
        if (this.roomOptions.length > 0) {
          this.localRoomOptions = [...this.roomOptions];
        } else {
          await this.loadRoomDataFallback(cid);
        }

        // 2. 加载字典、负责人
        if (!this.isDictLoaded) await this.loadDictData(true, cid);
        if (!this.isStaffLoaded) await this.loadStaffData(true, cid);

        // 3. 回显编辑数据，双层nextTick确保DOM渲染完成
        if (editData) {
          const tempData = { ...editData };

          // 处理房源roomId 字符串转数组
          if (tempData.roomId && typeof tempData.roomId === "string") {
            tempData.roomId = tempData.roomId.split(",").filter(id => !!id.trim());
          } else {
            tempData.roomId = [];
          }

          // 处理日期 截取时分秒
          if (tempData.expectedDealDate) {
            tempData.expectedDealDate = tempData.expectedDealDate.split(" ")[0];
          }

          // 延迟赋值，解决多选渲染滞后
          this.$nextTick(() => {
            this.$nextTick(() => {
              this.form = tempData;
              // 回显时重新计算面积
              this.calcTotalArea();
              // 清除全部校验提示
              this.$refs.form && this.$refs.form.clearValidate();
            });
          });
        }
      } catch (error) {
        this.$message.warning("部分数据加载失败，可能影响操作");
        console.error("弹窗数据加载异常:", error);
      }
    },

    resetForm() {
      if (this.$refs.form) this.$refs.form.resetFields();
      this.form = {
        opportunityName: "",
        customerName: "",
        source: "",
        status: "",
        expectedValue: null,
        responsiblePerson: "",
        roomId: [],
        expectedDealDate: "",
        description: "",
        attachments: "",
        opportunityType: "",
        industryType: "",
        negotiationProgress: "",
      };
      this.fileList = [];
      this.progress = 0;
      this.localRoomOptions = [];
    },

    async loadDictData(forceRefresh = false, communityId) {
      if (this.isDictLoaded && !forceRefresh) return;
      try {
        const dictParams = { communityId };
        const [sourceDict, statusDict, opportunityDict, negotiationDict] =
          await Promise.all([
            getDict("business_opportunity_source", "audit", dictParams),
            getDict("business_opportunity_status", "audit", dictParams),
            getDict("opportunity_type", "audit", dictParams),
            getDict("negotiation_progress", "audit", dictParams),
          ]);
        // 过滤无效数据，保证key唯一
        this.sourceOptions = sourceDict.filter(item => item && item.statusCd);
        this.statusOptions = statusDict.filter(item => item && item.statusCd);
        this.opportunityTypeOptions = opportunityDict.filter(item => item && item.statusCd);
        this.negotiationProgressOptions = negotiationDict.filter(item => item && item.statusCd);
        this.isDictLoaded = true;
      } catch (error) {
        this.isDictLoaded = false;
        console.error("字典数据加载异常:", error);
        throw error;
      }
    },

    async loadStaffData(forceRefresh = false, communityId) {
      if (this.isStaffLoaded && !forceRefresh) return;
      try {
        const params = { page: 1, row: 1000, communityId };
        const res = await selectStaffInfos(params);
        this.userOptions = res.staffs || [];
        this.isStaffLoaded = true;
      } catch (error) {
        this.isStaffLoaded = false;
        console.error("负责人数据加载异常:", error);
        throw error;
      }
    },

    async loadRoomDataFallback(communityId) {
      try {
        const res = await getRoomInfoByCommunity({ communityId });
        this.localRoomOptions = res || [];
      } catch (error) {
        console.error("房源数据兜底加载异常:", error);
        this.localRoomOptions = [];
        throw error;
      }
    },

    handleUploadSuccess(response, file) {
      if (response.data.url) {
        file.url = response.data.url;
        this.fileList = [file];
        this.$message.success("文件上传成功");
      } else {
        this.$message.error("文件上传失败：未获取到文件地址");
      }
    },

    handleRemove(file, fileList) {
      this.fileList = fileList;
      this.form.attachments = "";
    },

    async saveBusinessOpportunity() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return;
        try {
          const attachmentUrls = this.fileList
            .filter((file) => file.url)
            .map((file) => file.url)
            .join(",");
          this.form.attachments = attachmentUrls;

          const submitData = { ...this.form };
          // 提交接口带上小区ID
          submitData.communityId = this.communityId || getCommunityId();

          if (Array.isArray(submitData.roomId)) {
            submitData.roomId = submitData.roomId.join(",");
          }

          const res = await saveBusinessOpportunity(submitData);
          if (res.code === 0) {
            this.$message.success("商机保存成功");
            this.handleClose();
            this.$emit("success");
          } else {
            this.$message.error(res.msg || "商机保存失败");
          }
        } catch (error) {
          this.$message.error("操作失败：" + error.message);
          console.error("保存商机异常:", error);
        }
      });
    },

    disabledPastDate(date) {
      return date && date < new Date(new Date().setHours(0, 0, 0, 0));
    },

    handleClose() {
      this.visible = false;
      // 关闭弹窗强制重置，清空临时自定义选项，杜绝重复key
      this.resetForm();
    },

    async refreshDict() {
      const cid = this.communityId || getCommunityId();
      await this.loadDictData(true, cid);
      await this.loadStaffData(true, cid);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-upload__tip {
  margin-top: 6px;
  font-size: 13px;
  color: #606266;
}
::v-deep .el-form-item__content {
  line-height: 1.2;
}
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  padding: 12px 24px 24px;
  margin-top: 12px;
}
::v-deep .el-upload-dragger {
  padding: 30px 0;
}
/* 只读输入框置灰样式 */
::v-deep input[readonly] {
  background-color: #f5f7fa;
  cursor: not-allowed;
}
</style>